import type { BooksHealthRepository } from "../repositories/BooksHealthRepository";
import type { BooksMonthStatusItemEntity } from "../entities/BooksHealthEntity";

export class GetBooksHealthMonthByMonthUseCase {
  constructor(private repository: BooksHealthRepository) {}

  async execute(limit = 12): Promise<BooksMonthStatusItemEntity[]> {
    return this.repository.getBooksHealthMonthByMonth(limit);
  }
}

